import { ScreenProtocolMessage } from "../../ScreenProtocol";
import { FreegameSession } from "./FreegameSession";

export namespace FreegameMessages {
	
	export class PickMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "pick";
		public session: FreegameSession = null;

		constructor(session: FreegameSession) {
			super(PickMessage.msgname);
			this.session = session;
		}
	}

	export class SpinMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "spin";
		public session: FreegameSession = null;

		constructor(session: FreegameSession) {
			super(SpinMessage.msgname);
			this.session = session;
		}
	}

	export class PlusMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "plus";
		public session: FreegameSession = null;

		constructor(session: FreegameSession) {
			super(PlusMessage.msgname);
			this.session = session;
		}
	}

	export class WinMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "win";
		public session: FreegameSession = null;

		constructor(session: FreegameSession) {
			super(WinMessage.msgname);
			this.session = session;
		}
	}

	export class WinInterruptedMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "wininterrupt";

		constructor() {
			super(WinInterruptedMessage.msgname);
		}
	}

	export class ShowWinContainer extends ScreenProtocolMessage
	{
		public static readonly msgname = "showwincontainer";
		public session: FreegameSession = null;

		constructor(session: FreegameSession) {
			super(ShowWinContainer.msgname);
			this.session = session;
		}
	}
	
	export class ResetFinalContainerWin extends ScreenProtocolMessage
	{
		public static readonly msgname = "resetwinshowcontainer";
		public session: FreegameSession = null;
		constructor(session: FreegameSession) {
			super(ResetFinalContainerWin.msgname);
			this.session = session;
		}
	}
}